export interface CommencementNotificationDocument {
    id: number;
    notification_id: number;
    path: string | null;
    extension: string | null;
}

// Single object mapping
export const mapCommencementNotificationDocument = (data: any): CommencementNotificationDocument => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const response: CommencementNotificationDocument = {
        id: data?.id,
        notification_id: data?.notification_id,
        path: data?.path,
        extension: data?.extension,
    };

    return response;
};

// List mapping
export const mapCommencementNotificationDocuments = (data: any[]): CommencementNotificationDocument[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapCommencementNotificationDocument);
};

/*  */
export interface CommencementNotification {
    id: number;
    project_id: number;
    folder_id: number;
    date: string | null;
    description: string | null;
    notification_document: CommencementNotificationDocument[];
}

// Single object mapping
export const mapCommencementNotification = (data: any): CommencementNotification => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const response: CommencementNotification = {
        id: data?.id,
        project_id: data?.project_id,
        folder_id: data?.folder_id,
        date: data?.date || null,
        description: data?.description || null,
        notification_document: Array.isArray(data?.notification_document)
            ? mapCommencementNotificationDocuments(data?.notification_document)
            : [],
    };

    return response;
};

// List mapping
export const mapCommencementNotifications = (data: any[]): CommencementNotification[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapCommencementNotification);
};
